export const GET_TPV_AUDIT_LIST='GET_TPV_AUDIT_LIST';
export const GET_TPV_NC_LIST='GET_TPV_NC_LIST';
export const GET_AUDITOR_LIST='GET_AUDITOR_LIST';
export const API_CALL_STATUS='API_CALL_STATUS';
export const IS_AUDITOR_PLAN_LIST='IS_AUDITOR_PLAN_LIST';



